import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { getSchema } from './helper'
import classes from './index.module.scss'
import { selectCellData, selectIds, selectSortTable, sort } from './store/slice'

const AUTO_MAX_HEIGHT_TABLE = 264

const TableComponent = ({ isCreditScore, isDynamicReport }) => {
  const dispatch = useDispatch()
  const schema = getSchema(isCreditScore, isDynamicReport)

  const ids = useSelector(selectIds)
  const sortTable = useSelector(selectSortTable)

  const changeSort = (data) => {
    dispatch(sort(data))
  }

  return (
    <div className={isDynamicReport ? '' : classes.container}>
      {!isDynamicReport && ids.length > 0 && (
        <Element
          className={classes.title}
          style={{ fontSize: 14, color: '#191D25' }}
        >
          <Translate value={'portfolio.segment.VIET_NAM'} />
        </Element>
      )}
      <div
        className={`${isDynamicReport && 'flex1'} ${
          ids.length === 0 &&
          !isDynamicReport &&
          'flex1 dFlex justifyContentCenter alignItemsCenter'
        }  minH0`}
      >
        <Table
          ids={ids}
          isDynamicReport={isDynamicReport}
          isDisplayScroll={!isDynamicReport}
          isNoStickyHead={isDynamicReport}
          getDataFromRedux={selectCellData}
          schema={schema}
          sort={sortTable}
          changeSort={changeSort}
          autoHeightMax={AUTO_MAX_HEIGHT_TABLE}
        />
      </div>
    </div>
  )
}

export default TableComponent
